import type { useConfirmModal } from '@affine/component';

/** Opens a confirm modal and resolves true on confirm, false on any close. */
export function confirmByModal({
  openConfirmModal,
  title,
  description,
  confirmText,
  cancelText,
}: {
  openConfirmModal: ReturnType<typeof useConfirmModal>['openConfirmModal'];
  title: string;
  description: string;
  confirmText: string;
  cancelText: string;
}): Promise<boolean> {
  return new Promise(resolve => {
    let settled = false;
    const settle = (value: boolean) => {
      if (settled) return;
      settled = true;
      resolve(value);
    };
    openConfirmModal({
      title,
      description,
      confirmText,
      cancelText,
      onCancel: () => settle(false),
      onOpenChange: open => {
        if (!open) settle(false);
      },
      onConfirm: () => settle(true),
    });
  });
}
